var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOther = function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-5 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0m-4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6-1a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
  })));
};
export default SvgOther;